module.exports = __webpack_public_path__ + "static/media/pip_logo_small.e8492258.svg";